export default {
    toolbar: {
        toolbar: 'Dashboard'
    }
}